import React from 'react';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { RenovationProgramFilter } from '../../../../models/Filter';
import { RenovationProgramButtonFilterView } from '../../desktop/renovation_program/RenovationProgramButtonFilterView';

interface IRenovationProgram {
    filter: RenovationProgramFilter;
    handleChange: (filter: RenovationProgramFilter) => void;
}

export const MobileRenovationProgramFilterButtonView: React.FC<IRenovationProgram> = ({
    filter,
    handleChange
}) => {
    return (
        <MobileFilter2 filterTitle='Реновация'>
            <RenovationProgramButtonFilterView
                filter={filter}
                handleChange={handleChange}
            />
        </MobileFilter2>
    );
};
